import { ReactNode } from 'react';
import { FormApi } from 'final-form';
import { IApiResponse, ITransferBeneficiary } from 'utils/models';

export const FAB_BANK = { code: '300316', name: 'First Atlantic Bank' };

export type FormType = FormApi<IFormValues, Partial<IFormValues>>;

export const bulkDataConfig = {
  sourceAccount: 'Source Account:',
  numberOfTransactions: 'Number of Transactions:',
  totalAmount: 'Total Amount:',
};

export const bulkSortArray = [
  'Source Account:',
  'Number of Transactions:',
  'Total Amount:',
];

export const types = [
  { name: 'INSTANT TRANSFER', key: 'INSTANT' },
  { name: 'NON-INSTANT TRANSFER', key: 'NON_INSTANT' },
];

export interface IExtraFields {
  destinationBankName: string;
  destinationBankCode: string;
  destinationAccountName: string;
  destinationIsExistingBen: boolean;
  beneficiaryId?: number;
  charge?: number;
}

export interface ITransfersState {
  transferBeneficiaries: ITransferBeneficiary[];
  types: typeof types;
  banks: IBank[];
  isLookingUp?: boolean;
  extras: IExtraFields;
  lastLookedUpAccount: string;
  lastLookedUpBankCode: string;
}

export interface IFormValues {
  sourceAccount: string;
  transferData: {
    customerId: string;
    cardLastDigit: string;
    cardName: string;
    phoneNumber: string;
    amount: string;
    narration: string;
  }[]
}

export interface ITransactionField {
  label: ReactNode;
  value: ReactNode;
}

export interface IBank {
  code: string;
  name: string;
}

export interface ICardLoadResponse extends IApiResponse {
  transactionId: number;
}

export interface IAccountLookup {
  name: string;
  beneficiaryId?: number;
}

export interface ILocalLookupRes extends IApiResponse {
  accountName: string;
}

export interface IGetTransferBeneficiaries extends IApiResponse {
  beneficiaries: ITransferBeneficiary[];
}

export interface IGetBankInstitutions extends IApiResponse {
  banks: IBank[];
}

export interface INonInstantBank {
  BankSortCode: string;
  BankName: string;
  BankShortName: string;
}

export type IBanksMappedList = { INSTANT: IBank[]; NON_INSTANT: IBank[] };

export interface IGetNonInstantBanks extends IApiResponse {
  banks: INonInstantBank[];
}

export interface ITransferCharge extends IApiResponse {
  charge: number;
}

export interface ITransferActions {
  getTransactionCharge: (amount: string | number) => void;
  findBeneficiaryName: (values: IFormValues) => void;
  handleSelectBank: (bankCode: string) => void;
}

export interface IFormCommonFields {
  sourceAccount: string;
  amount: number | string;
  destinationAccountNo: string;
  narration: string;
  destinationBankCode: string;
}

export type BankTypeKeys = 'INSTANT' | 'NON_INSTANT';

export interface IBulkCommonFields extends IFormCommonFields, IExtraFields {
  currencyCode: string;
  saveBen: boolean;
  eLevyFee: string;
  transferType?: BankTypeKeys;
  totalAmount: number;
  transactionAmount: string | number;
}

export interface IBulkCardData
  extends Pick<
    IBulkCommonFields,
    | 'destinationAccountNo'
    | 'eLevyFee'
    | 'sourceAccount'
    | 'narration'
    | 'destinationAccountName'
    | 'transferType'
    | 'transactionAmount'
    | 'totalAmount'
  > {
  destinationBankName?: string;
  transactionCharge?: string | number;
}

export type IBulkStatusModalP = {
  open: boolean;
  status: 'success' | 'failure';
  content: React.ReactChild;
}

export interface IBulkTransferData {
  Amount: number | string;
  DestinationAccountNo: string;
  Narration: string;
  DestinationBankCode: string;
  DestinationAccountName: string;
  CurrencyCode: string;
  SaveBen: boolean;
}

export interface IBulkTransferBody {
  sourceAccount: string;
  sourceAccountType: string;
  passwordType: string;
  password: string;
  bulkTransferData: IBulkTransferData[] | string;
}

export type IHandleFieldsChange = () => void;

export interface IElevyState {
  charge: string,
  taxableAmount: string,
  eLevyId: string,
}

export interface IElevyResponse extends IApiResponse {
  charge: string,
  taxableAmount: string,
  eLevyId: string,
}
